import React, { useEffect, useState } from 'react'

const OptionsTitle = (props) => {
   const { currentStepIndex, listData } = props
   const [optionName, setOptionName] = useState(null)

   useEffect(() => {
      setOptionName(listData[currentStepIndex].name)
   }, [currentStepIndex, listData])
   return (
      <h6>Options: {optionName}</h6>
   )
}
export default OptionsTitle